function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0-shopbag{fill:none;stroke:#fff;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0-shopbag",
  d: "M21.5,17.5c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0-shopbag",
  d: "M34.5,17.5c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0-shopbag",
  d: "M18.7,17.5c0,0-3.4-14.5,6.5-14.5s6.5,14.5,6.5,14.5"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0-shopbag",
  points: "11.8,13.7 37.9,13.7 41.9,44.1 8,44.1 "
});

var SvgShopbag = function SvgShopbag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShopbag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopbag.9256f4c4.svg";
export { ForwardRef as ReactComponent };